// -----------------------------------------------------------
// FloraIQ — Aba Validação Arbórea
// -----------------------------------------------------------

import { treeInconsistencies } from "@/mocks/quality";
import { QualityScoreBadge } from "./QualityStatusBadge";

export default function TreeValidationPanel() {
  const semEspecie = treeInconsistencies.filter((t) => t.camposAusentes.includes("Espécie")).length;
  const semDap = treeInconsistencies.filter((t) => t.camposAusentes.includes("DAP")).length;
  const semFito = treeInconsistencies.filter((t) => t.camposAusentes.includes("Fitossanidade")).length;
  const semRisco = treeInconsistencies.filter((t) => t.camposAusentes.includes("Risco")).length;
  const semRecomendacao = treeInconsistencies.filter((t) => t.camposAusentes.includes("Recomendação")).length;
  const pendenteRevisao = treeInconsistencies.filter((t) => t.camposAusentes.includes("Revisão") || t.camposAusentes.includes("Status de revisão")).length;

  return (
    <div className="space-y-6">
      {/* Painéis resumo */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {[
          { label: "Sem Espécie", value: semEspecie, icon: "ri-plant-line", color: "red" },
          { label: "Sem DAP/CAP", value: semDap, icon: "ri-ruler-line", color: "orange" },
          { label: "Sem Fitossanidade", value: semFito, icon: "ri-heart-pulse-line", color: "orange" },
          { label: "Sem Risco", value: semRisco, icon: "ri-error-warning-line", color: "red" },
          { label: "Sem Recomendação", value: semRecomendacao, icon: "ri-tools-line", color: "yellow" },
          { label: "Pendentes de Revisão", value: pendenteRevisao, icon: "ri-file-edit-line", color: "yellow" },
        ].map((p) => (
          <div key={p.label} className="bg-white rounded-card border border-background-200/70 p-3">
            <div className="flex items-center gap-2 mb-1">
              <div className={`w-7 h-7 rounded-lg flex items-center justify-center ${
                p.color === "red" ? "bg-red-100 text-red-600" : p.color === "orange" ? "bg-orange-100 text-orange-600" : "bg-yellow-100 text-yellow-600"
              }`}>
                <i className={`${p.icon} text-xs`}></i>
              </div>
              <span className="text-xs font-medium text-foreground-600 truncate">{p.label}</span>
            </div>
            <p className="text-lg font-bold font-heading text-foreground-900">{p.value}</p>
          </div>
        ))}
      </div>

      {/* Tabela */}
      <div className="overflow-x-auto border border-background-200/70 rounded-card">
        <table className="w-full text-xs">
          <thead>
            <tr className="bg-background-50 border-b border-background-200/70">
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Código CTA</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Espécie</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Projeto</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Campos Ausentes</th>
              <th className="text-center px-3 py-2.5 font-medium text-foreground-600">Qualidade</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Ação Recomendada</th>
              <th className="text-center px-3 py-2.5 font-medium text-foreground-600">Ações</th>
            </tr>
          </thead>
          <tbody>
            {treeInconsistencies.map((t) => (
              <tr key={t.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="px-3 py-2.5 font-mono text-foreground-700">{t.codigoCta}</td>
                <td className="px-3 py-2.5 text-foreground-600">{t.especie}</td>
                <td className="px-3 py-2.5 text-foreground-600 max-w-[140px] truncate">{t.projeto}</td>
                <td className="px-3 py-2.5 text-foreground-700 max-w-[200px] truncate">{t.camposAusentes}</td>
                <td className="px-3 py-2.5 text-center">
                  <span className="text-xs font-medium text-foreground-600">{t.qualidadeCadastro}</span>
                </td>
                <td className="px-3 py-2.5 text-foreground-600 max-w-[240px] truncate">{t.acaoRecomendada}</td>
                <td className="px-3 py-2.5 text-center">
                  <button className="w-7 h-7 rounded-lg flex items-center justify-center hover:bg-background-100 transition-colors cursor-pointer" title="Abrir FCA">
                    <i className="ri-file-text-line text-foreground-500 text-sm"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}